/**
 * THE CELL SWITCH — the Pro Hub on Tenean's own AWS cell (move map M28). DARK.
 *
 * Nothing here runs unless the build sets VITE_TENEAN_CELL=cell-00, which only the AWS staging build does
 * (.github/workflows/aws-hub-staging.yml). The Cloudflare build (wrangler.toml, deploy.yml) never sets it, so
 * production keeps Supabase sign-in and Supabase reads exactly as today; cell.guard.test.ts fails if a Cloudflare
 * config or workflow ever sets it.
 *
 * When on: sign-in is Tenean's Cognito pool (tenean-users, the Pro Hub client), every read and write is a call to
 * Tenean's API (one endpoint per screen action, same origin: CloudFront sends /v1/* to API Gateway), live updates
 * come from AppSync Events, and no request goes to Supabase (the parity walk counts them: zero).
 */
const env = import.meta.env as Record<string, string | undefined>;

export const CELL: string | null = env.VITE_TENEAN_CELL === 'cell-00' ? 'cell-00' : null;
export const isCell = (): boolean => CELL !== null;

export const COGNITO = {
  region: env.VITE_COGNITO_REGION ?? 'us-east-2',
  userPoolId: env.VITE_COGNITO_USER_POOL_ID ?? '',
  clientId: env.VITE_COGNITO_CLIENT_ID ?? '',
};

/** The API's base: '' = this origin (CloudFront routes /v1/* and /functions/v1/* to the API). */
export const API_BASE = (env.VITE_TENEAN_API_BASE ?? '').replace(/\/+$/, '');

/** AppSync Events (M17): the realtime host (wss) and HTTP host, from TeneanRealtime00's outputs. */
export const EVENTS = {
  realtimeHost: env.VITE_TENEAN_EVENTS_REALTIME_HOST ?? '',
  httpHost: env.VITE_TENEAN_EVENTS_HTTP_HOST ?? '',
};

/** Public media (/m/…) on AWS: the media copy's staging CloudFront (TeneanMediaStaging, M14). */
export const CELL_MEDIA_ORIGIN: string | null = env.VITE_TENEAN_MEDIA_ORIGIN ? env.VITE_TENEAN_MEDIA_ORIGIN.replace(/\/+$/, '') : null;

/** The storage ADDRESS format photos are recorded with (…/storage/v1/object/authenticated/<bucket>/<path>). Kept the
 *  same on the cell so a stored address is identical either side of the cutover; it is only text — the cell signs
 *  every such address through the API (lib/cell/files.ts), it never contacts that host. */
export const CELL_STORED_STORAGE_ORIGIN: string = (env.VITE_TENEAN_STORED_STORAGE_ORIGIN ?? '').replace(/\/+$/, '');

/** The Owner Hub's doors (/pro/*) on AWS: the web app's staging host once it serves them over HTTPS (M15). Unset =
 *  those features say they are not on the AWS staging build yet, instead of calling production. */
export const CELL_OWNER_HUB_ORIGIN: string | null = env.VITE_TENEAN_WEB_ORIGIN ? env.VITE_TENEAN_WEB_ORIGIN.replace(/\/+$/, '') : null;
